// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1KU4o","errorLogs":"styles_errorLogs__267LR"};